import { Button } from "@material-ui/core"
import { EdgeMediaQuery, IEMediaQuery } from "common/MediaQueries"
import { setOpen } from "components/shopFeatures/auth/authSlice"
import ContactDialog from "components/shopFeatures/contact/ContactDialog"
import { StyledContainer as StyledBottomBarContainer } from "components/shopFeatures/wizard/bottomBar/Container"
import { SIDEBAR_WIDTH } from "components/shopFeatures/wizard/constants"
import { useState } from "react"
import { Link } from "react-router-dom"
import routes from "routes"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"

export const HEIGHT = 100

const StyledContainer = styled(StyledBottomBarContainer)`
  box-shadow: 0 -5px 25px 0 rgba(0, 0, 0, 0.06);
  flex-direction: column;
  align-items: stretch;

  ${(p) => p.theme.breakpoints.down("sm")} {
    height: ${HEIGHT}px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    height: ${HEIGHT}px;
    box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.06);
    border-top: none;
    position: sticky;
    bottom: -20px;
    margin: 0px -20px -20px;
  }

  ${IEMediaQuery} {
    position: fixed;
    bottom: 0;
    width: ${SIDEBAR_WIDTH}px;
    margin-bottom: 0;
  }
  ${EdgeMediaQuery} {
    position: fixed;
    bottom: 0;
    width: ${SIDEBAR_WIDTH}px;
    margin-bottom: 0;
  }
`
const StyledContactMeButton = styled(Button)`
  text-decoration: underline;
  margin-top: 4px;
  margin-bottom: -10px;
  align-self: center;

  :hover {
    text-decoration: underline;
  }
`

const PurchaseButtonBox = () => {
  const { authenticated } = useTypedSelector((state) => state.auth)

  const dispatch = useAppDispatch()

  const [openContact, setOpenContact] = useState(false)

  return (
    <>
      <StyledContainer>
        <Button
variant="outlined"
          color="primary"
          {...(authenticated
            ? // If authenticated, link to order page
              { component: Link, to: routes.order.path }
            : // Otherwise, open the auth dialog
              { onClick: () => dispatch(setOpen(true)) })}
          role="link"
        >
          {authenticated ? "לתשלום מקדמה" : "לחשיפת ההטבות"}
        </Button>

        <StyledContactMeButton onClick={() => setOpenContact(true)}>
          חזרו אליי טלפונית
        </StyledContactMeButton>
      </StyledContainer>

      <ContactDialog open={openContact} onClose={() => setOpenContact(false)} />
    </>
  )
}

export default PurchaseButtonBox
